// import { useEffect } from "react";
import { marked } from "marked";
import { convertMultipleNewlinesToBR } from "../exports/functions";

const ChairmenMessage = (props) => {
  const { chairmanData, reverse } = props;

  const rawDescription = chairmanData[0]?.message || "";
  const description = convertMultipleNewlinesToBR(rawDescription);
  // useEffect(() => {
  //   const loadSlick = async () => {
  //     if (typeof window !== "undefined") {
  //       const $ = (await import("jquery")).default;
  //       require("slick-carousel");

  //       const thumbsSlider = $(".testimonials__thumbs-slider");
  //       const mainSlider = $(".testimonials__slider");

  //       if (thumbsSlider.length && mainSlider.length) {
  //         // Initialize the sliders
  //         thumbsSlider.slick({
  //           slidesToShow: 1,
  //           slidesToScroll: 1,
  //           arrows: false,
  //           fade: true,
  //           rtl: $("html").attr("dir") === "rtl",
  //           asNavFor: ".testimonials__slider",
  //         });

  //         mainSlider.slick({
  //           slidesToShow: 1,
  //           slidesToScroll: 1,
  //           asNavFor: ".testimonials__thumbs-slider",
  //           dots: false,
  //           arrows: true,
  //           rtl: $("html").attr("dir") === "rtl",
  //           focusOnSelect: true,
  //           nextArrow: "#testimonials-next",
  //           prevArrow: "#testimonials-prev",
  //         });
  //       }
  //     }
  //   };

  //   loadSlick();

  //   return () => {
  //     if (typeof window !== "undefined") {
  //       const $ = require("jquery");
  //       // Destroy sliders on unmount
  //       $(".testimonials__thumbs-slider").slick("unslick");
  //       $(".testimonials__slider").slick("unslick");
  //     }
  //   };
  // }, []);
  return (
    <section className="testimonials py-80 position-relative z-1 bg-main-25">
      <div className="container">
        <div
          className={`row gy-5 align-items-stretch ${
            reverse ? "flex-lg-row-reverse" : ""
          }`}
        >
          <div className="col-lg-5">
            <div className={reverse ? "ps-lg-5 ms-xxl-5" : "pe-lg-5 me-xxl-5"}>
              <div
                className="testimonials__thumbs wow bounceIn text-center"
                data-tilt=""
                data-tilt-max={15}
                data-tilt-speed={500}
                data-tilt-perspective={5000}
                data-tilt-full-page-listening=""
              >
                <img
                  src={
                    chairmanData[0]?.image[0]?.media?.url &&
                    `${process.env.REACT_APP_cmsUrl}${chairmanData[0]?.image[0]?.media?.url}`
                  }
                  alt=""
                />
              </div>
            </div>
          </div>
          <div className="col-lg-7">
            <div className="testimonials__content">
              <div className="style-left" id="chairmen">
                <div className="flex-align gap-8 mb-16 wow bounceInDown">
                  <span className="text-main-600 text-2xl d-flex">
                    <i className="ph-bold ph-book-open" />
                  </span>
                  <h5 className="text-main-600 mb-0">
                    {chairmanData[0]?.snippet}
                  </h5>
                </div>
                <h2 className="mb-24 wow bounceIn">{chairmanData[0]?.title}</h2>
              </div>
              {/* <div className="testimonials__slider"> */}
              <div>
                <div className="testimonials-item">
                  <p
                    className="text-neutral-700"
                    data-aos="fade-left"
                    data-aos-duration={1200}
                    dangerouslySetInnerHTML={{
                      __html: marked(description),
                    }}
                  ></p>
                  <h4 className="mt-48 mb-8 text-end" data-aos="fade-left">
                    {chairmanData[0]?.name}
                  </h4>
                  <span
                    className="text-neutral-700 text-end d-block"
                    data-aos="fade-left"
                  >
                    {chairmanData[0]?.position}
                  </span>
                </div>
              </div>
              {/* <div className='flex-align gap-16 mt-40'>
                <button
                  type='button'
                  id='testimonials-prev'
                  className=' slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1 w-48 h-48'
                >
                  <i className='ph ph-caret-left' />
                </button>
                <button
                  type='button'
                  id='testimonials-next'
                  className=' slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1 w-48 h-48'
                >
                  <i className='ph ph-caret-right' />
                </button>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ChairmenMessage;
